module.exports = __webpack_public_path__ + "static/Pricing-Mobile-614c22018e3f27b8c21cd22febcb4791.png";